import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Customer } from 'server/shared/models/customer';
import { Invitee } from 'server/shared/models/invitee';
import { InviteeStatusEnum } from 'server/shared/models/jobInviteeStatusEnum';

@Component({
  selector: 'app-job-list-item-compact-invitees',
  templateUrl: './job-list-item-compact-invitees.component.html',
  styleUrls: ['./job-list-item-compact-invitees.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JobListItemCompactInviteesComponent {
  invitee$ = new BehaviorSubject<Invitee | undefined>(undefined);
  @Input() set invitee(value: Invitee | undefined) {
    this.invitee$.next(value);
  }
  get invitee() {
    return this.invitee$.value;
  }

  customer$ = new BehaviorSubject<Customer | undefined>(undefined);
  @Input() set customer(value: Customer | undefined) {
    this.customer$.next(value);
  }
  get customer() {
    return this.customer$.value;
  }

  extraInviteeCount$ = new BehaviorSubject<number | undefined>(undefined);
  @Input() set extraInviteeCount(value: number | undefined) {
    this.extraInviteeCount$.next(value);
  }
  get extraInviteeCount() {
    return this.extraInviteeCount$.value;
  }

  inviteeStatusEnum = InviteeStatusEnum;

  constructor() {}
}
